import { RouterProvider, createHashRouter } from 'react-router-dom';
import { buildAppRoutes } from './route-config';

const router = createHashRouter(buildAppRoutes());

export function AppRouter(): JSX.Element {
  return <RouterProvider router={router} />;
}
